import _classCallCheck from "/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { connect } from "../core/context/ToneAudioNode";
import { Param } from "../core/context/Param";
import { optionsFromArguments } from "../core/util/Defaults";
import { OneShotSource } from "../source/OneShotSource";
/**
 * Wrapper around the native fire-and-forget ConstantSource.
 * Adds the ability to reschedule the stop method.
 * @category Signal
 */
export var ToneConstantSource = /*#__PURE__*/function (_OneShotSource) {
  _inherits(ToneConstantSource, _OneShotSource);
  var _super = _createSuper(ToneConstantSource);
  function ToneConstantSource() {
    var _this;
    _classCallCheck(this, ToneConstantSource);
    _this = _super.call(this, optionsFromArguments(ToneConstantSource.getDefaults(), arguments, ["offset"]));
    _this.name = "ToneConstantSource";
    /**
     * The signal generator
     */
    _this._source = _this.context.createConstantSource();
    var options = optionsFromArguments(ToneConstantSource.getDefaults(), arguments, ["offset"]);
    connect(_this._source, _this._gainNode);
    _this.offset = new Param({
      context: _this.context,
      convert: options.convert,
      param: _this._source.offset,
      units: options.units,
      value: options.offset,
      minValue: options.minValue,
      maxValue: options.maxValue
    });
    return _this;
  }
  _createClass(ToneConstantSource, [{
    key: "start",
    value:
    /**
     * Start the source node at the given time
     * @param  time When to start the source
     */
    function start(time) {
      var computedTime = this.toSeconds(time);
      this.log("start", computedTime);
      this._startGain(computedTime);
      this._source.start(computedTime);
      return this;
    }
  }, {
    key: "_stopSource",
    value: function _stopSource(time) {
      this._source.stop(time);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(ToneConstantSource.prototype), "dispose", this).call(this);
      if (this.state === "started") {
        this.stop();
      }
      this._source.disconnect();
      this.offset.dispose();
      return this;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return Object.assign(OneShotSource.getDefaults(), {
        convert: true,
        offset: 1,
        units: "number"
      });
    }
  }]);
  return ToneConstantSource;
}(OneShotSource);